import { Injectable } from '@angular/core'
import { Subject }    from 'rxjs/Subject';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class EventsService {
  // Observable  sources
  private isSearchInvokedSource = new Subject<Object>();
  private isAddressValidSource = new Subject<boolean>();
  private validatedBirthdateSource = new Subject<string>();
  private selectedAddressSource = new BehaviorSubject<Object>(0);
  private activeTabSource  = new Subject<string>();
  private pollingPlaceSource = new BehaviorSubject<Object>(0);
  private satellitesSource = new BehaviorSubject<Object>(0);
  private mapLocationSource = new BehaviorSubject<Object>(0);
  private updatedLanguageSource = new Subject<string>();
  private directionsSource = new Subject<string>();
  private addressFromGeolocation = new Subject<Object>();
  private _startAddressFromGeolocation = new Subject();

  // Observable  streams
  searchInvoked$ = this.isSearchInvokedSource.asObservable();
  birthdate$ = this.validatedBirthdateSource.asObservable();
  addressValid$ = this.isAddressValidSource.asObservable();
  selectedAddressObject$ = this.selectedAddressSource.asObservable();
  activeTab$ = this.activeTabSource.asObservable();
  pollingPlace$ = this.pollingPlaceSource.asObservable();
  satellites$ = this.satellitesSource.asObservable();
  mapZoom$ = this.mapLocationSource.asObservable();
  languageChanged$ = this.updatedLanguageSource.asObservable();
  directionsInvoked$ = this.directionsSource.asObservable();
  addressFromGeolocation$ = this.addressFromGeolocation.asObservable();
  startAddressFromGeolocation$ = this._startAddressFromGeolocation.asObservable();

    //=============service commands to update observable streams======================
    
  //updated selected address object
  setSelectedAddress(Object) {
    this.selectedAddressSource.next(Object);
    this.isAddressValidSource.next(true);
  }

  // update search status
  voterSearchInvoked(Object) {
    // console.log("location search event sent!")
    this.isSearchInvokedSource.next(Object);
    // console.log("Location status is: " + locationStatus)
  }

//set address validation status
  voterAddressValid(addressStatus: boolean) {
    // console.log("location search event sent!")
    this.isAddressValidSource.next(addressStatus);
    // console.log("Location status is: " + locationStatus)
  }

//set entered birthdate status
  voterBirthdate(birthdateStatus: string) {
    this.validatedBirthdateSource.next(birthdateStatus);
  }

      //updated selected address object
  setActiveTab(tab:string) {
    this.activeTabSource.next(tab);
    // this.isAddressValidSource.next(true);
  }

  setPollingPlace(polling:Object) {

    this.pollingPlaceSource.next(polling);
  }

  setSatellites(satellitePolling:Array<Object>) {
    this.satellitesSource.next(satellitePolling);
  }

  zoomToLocation(location:Object) {
    this.mapLocationSource.next(location);
  }

  updateLanguage(language:string) {
    this.updatedLanguageSource.next(language);
  }

  getDirections(destination:string) {
    this.directionsSource.next(destination);
  }

  startAddressFromGeolocation(){
    this._startAddressFromGeolocation.next();
  }

  setAddressFromGeolocation(addressLocation:Object){
    this.addressFromGeolocation.next(addressLocation);
  }
}



// WEBPACK FOOTER //
// ./app/shared/Events.service.ts